import _typeof from "@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
import { addPageAction } from '@nike/ux-tread-new-relic';
import { getByPath } from './shared-utils';
var EVENT_NAME = 'Handling Cart Warning';

/**
 * All possible warning codes from buy/carts/v2 service:
 * - PRICE_CHANGED: Product price has changed
 * - QUANTITY_MODIFIED: Item quantity was adjusted
 * - PRODUCT_REMOVED: Product was removed from cart
 * - PROMOTION_NOT_APPLIED: Promotion code could not be applied
 * - COUNTRY_NOT_SUPPORTED: Country is not supported for this operation
 */

/**
 * Warning codes that should be displayed to users
 * Other warnings are logged but not displayed
 */
var DISPLAYABLE_WARNING_CODES = {
  COUNTRY_NOT_SUPPORTED: true,
  PROMOTION_NOT_APPLIED: true
};

/**
 * Warning codes that require auto-remediation
 */
var PROMO_CODE_WARNING_CODES = {
  PROMOTION_NOT_APPLIED: true
};

/**
 * Handles warnings returned from the buy/carts/v2 service
 * Logs all warnings to New Relic, removes invalid promo codes, and displays specific warnings to users
 * @param {Object} params - Parameters object
 * @param {Array} params.warnings - Array of warning objects from API response
 * @param {Object} params.data - Cart data from API response
 * @param {Object} queryClient - React Query client instance
 * @param {string} [params.promotionCode] - attempted promo code from mutation variables
 * @returns {Promise<Array>} The warnings array for potential upstream handling
 */
export default function handleCartWarnings(_x, _x2) {
  return _handleCartWarnings.apply(this, arguments);
}
function _handleCartWarnings() {
  _handleCartWarnings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, queryClient) {
    var warnings, data, promotionCode, invalidPromoCodes, hasPromoNotAppliedWarning, fallbackPromoCodes, promoCodesToRemove, handleRemovePromotionCode;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          warnings = _ref.warnings, data = _ref.data, promotionCode = _ref.promotionCode;
          if (!(!warnings || !Array.isArray(warnings) || warnings.length === 0)) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", warnings);
        case 1:
          // Extract invalid promo codes from warnings
          invalidPromoCodes = warnings.filter(function (warning) {
            return warning.field && typeof warning.field === 'string';
          }).reduce(function (accum, warning) {
            if (PROMO_CODE_WARNING_CODES[warning.code]) {
              try {
                // Convert field path (e.g., '/promotionCodes/0') to dot notation (e.g., 'promotionCodes.0')
                var fieldPath = warning.field.split('/').filter(function (x) {
                  return x;
                }).join('.');
                if (fieldPath) {
                  var promoCode = getByPath(data, fieldPath);
                  if (promoCode && typeof promoCode === 'string') {
                    return [].concat(_toConsumableArray(accum), [promoCode]);
                  }
                }
              } catch (fieldError) {
                addPageAction(EVENT_NAME, {
                  error: 'Error extracting promo code from warning field',
                  field: warning.field,
                  code: warning.code,
                  message: warning.message,
                  fieldError: fieldError.message
                });
              }
            }
            return accum;
          }, []);
          hasPromoNotAppliedWarning = warnings.some(function (warning) {
            return warning && PROMO_CODE_WARNING_CODES[warning.code];
          });
          fallbackPromoCodes = hasPromoNotAppliedWarning && promotionCode && typeof promotionCode === 'string' ? [promotionCode] : [];
          promoCodesToRemove = invalidPromoCodes.length > 0 ? invalidPromoCodes : fallbackPromoCodes; // Remove invalid promo codes if any found
          if (!(promoCodesToRemove.length > 0)) {
            _context.next = 3;
            break;
          }
          addPageAction(EVENT_NAME, {
            action: 'Removing invalid promotion codes from warnings',
            promotionCodes: promoCodesToRemove
          });
          _context.next = 2;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 2:
          handleRemovePromotionCode = _context.sent["default"];
          _context.next = 3;
          return handleRemovePromotionCode({
            promotionCode: promoCodesToRemove[0],
            queryClient: queryClient
          });
        case 3:
          // Log and display each warning
          warnings.forEach(function (warning) {
            var code = warning.code,
              message = warning.message,
              crcCode = warning.crcCode,
              field = warning.field;

            // Log all warnings to New Relic for monitoring
            addPageAction(EVENT_NAME, {
              warningCode: code,
              warningMessage: message,
              crcCode: crcCode,
              field: field,
              data: data
            });

            // Only display specific warning types to users
            if (DISPLAYABLE_WARNING_CODES[code]) {
              var _window$NikeShop;
              if ((_window$NikeShop = window.NikeShop) !== null && _window$NikeShop !== void 0 && (_window$NikeShop = _window$NikeShop.__INTERNAL_USE__) !== null && _window$NikeShop !== void 0 && (_window$NikeShop = _window$NikeShop.stores) !== null && _window$NikeShop !== void 0 && _window$NikeShop.errorModal) {
                window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(warning);
              }
            }
          });
          return _context.abrupt("return", warnings);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _handleCartWarnings.apply(this, arguments);
}